class WebSocketService {
  socket = null
  listeners = []

  connect (token, onConnected) {
    if (this.socket) return

    this.socket = new WebSocket(
      `${process.env.VUE_APP_WS_API}ws?access_token=${token}`,
      []
    )

    this.socket.onopen = () => {
      // console.log('🟢 WebSocket conectado')
      if (onConnected) onConnected()
    }

    this.socket.onmessage = event => {
      var message = null
      try {
        message = JSON.parse(event.data)
      } catch {
        message = event.data
      }
      this.listeners.forEach(cb => cb(message))
    }

    this.socket.onclose = () => {
      // console.log('🔴 WebSocket desconectado')
      this.socket = null
      setTimeout(() => this.connect(token), 3000)
    }

    this.socket.onerror = err => {
      console.error('WebSocket erro', err)
    }
  }

  send (payload) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(payload))
    }
  }

  subscribe (callback) {
    this.listeners.push(callback)
  }

  unsubscribe (callback) {
    this.listeners = this.listeners.filter(l => l !== callback)
  }

  close () {
    if (this.socket) {
      this.socket.close()
      this.socket = null
    }
  }

  joinGroup (groupName) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      throw new Error('WebSocket não está conectado')
    }

    const message = {
      type: 'command',
      action: 'joinGroup',
      data: {
        group: groupName
      }
    }

    this.socket.send(JSON.stringify(message))
  }
}

export default new WebSocketService()
